import { useIntl } from 'react-intl';
import styled from 'styled-components';

import Typography from 'app/ui/components/atoms/typography';

const Message = styled.div`
  padding: ${({ theme: { spacing } }) => spacing(6)} 0;
  text-align: center;
`;

export const LeadsFilteredEmpty = () => {
  const intl = useIntl();

  return (
    <Message data-testid="leads-filtered-empty">
      <Typography variant="body2">{intl.formatMessage({ id: 'leads.filteredEmpty' })}</Typography>
    </Message>
  );
};

export default LeadsFilteredEmpty;
